export default [
  {
    path: '/groups',
    name: 'groups-list',
    props: true,
    component: () => import('@/views/groups/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Liste des groups',
      breadcrumb: [
        {
          text: 'groups',
        },
        {
          text: 'Liste des groups',
          active: true,
        },
      ],
    },
  },
  {

    path: '/group/create',
    name: 'group-add',
    props: true,
    component: () => import('@/views/groups/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Ajouter group',
      breadcrumb: [
        {
          text: 'group',
        },
        {
          text: 'Ajouter group',
          active: true,
        },
      ],
    },
  },

  {

    path: '/group/edit/:id',
    name: 'group-edit',
    props: true,
    component: () => import('@/views/groups/Edit.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Modifier group',
      breadcrumb: [
        {
          text: 'group',
        },
        {
          text: 'Modifier group',
          active: true,
        },
      ],
    },
  },

]
